module.exports = __webpack_public_path__ + "static/media/Powerful visual programming tools in Maya.939ff72b.png";